var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_communications_np_vinccrmnp_cloud_remoteEntry_js_f565c453__;